var React = require('react');
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var PropTypes = require('react').PropTypes;
var SurveyActions = require('../../../modules/survey/actions/surveys-fetch');
var surveyMetaActions = require('../../../modules/meta/actions/survey');
var modalActions = require( '../../../modules/modals/actions/modal');
var Callout = require('../../components/callout.jsx');

var checkSurveys = function(Component) {
    var SurveyComponent = createReactClass({

      componentDidMount: function() { //when component first mounts
          if(this.props.surveys.surveyType === 'promis' && this.props.isUserPromisSurveyAlreadyTaked){
              this.props.showModal('MODAL_TYPE_PROMIS', {
                  close: function(){
                      this.context.router.replace('/dashboard/mygi');
                  }.bind(this)
              });
          }else{
              this.setSurveys();
          }
      },

      setSurveys: function() {
          this.props.fetchSurveysIfNeeded(this.props.surveys.index.join(), this.props.auth.token).then(function(){
              if(Object.keys(this.props.surveys.error).length === 0 && this.props.surveys.data.length !== 0){
                  this.props.recordSurveyStarted(this.props.location.pathname.toLowerCase());
              }
          }.bind(this));
      },

      render: function() {
          var content = null;

          if(!this.props.surveys.isFetching){
              if(Object.keys(this.props.surveys.error).length > 0){
                  content = (
                      <div className="row">
                          <div className="column">
                              <Callout type="alert" message={this.props.surveys.error.message ? this.props.surveys.error.message : this.props.surveys.error} handleClose={this.props.clearSurveysError} />
                          </div>
                      </div>
                  );
              }else if(this.props.surveys.data.length !== 0 && !(this.props.surveys.surveyType === 'promis' && this.props.isUserPromisSurveyAlreadyTaked)){
                  content = <Component {...this.props} />;
              }
          }

         return content;
      },

      // for making this.context.router available
      contextTypes: {
          router: PropTypes.object.isRequired
      }
    });


    checkSurveys.propTypes = {
      fetchSurveysIfNeeded: PropTypes.func.isRequired,
      clearSurveysError: PropTypes.func.isRequired,
      surveys: PropTypes.object,
      auth: PropTypes.object
    };

  var mapStateToProps = function(state){
      return {
        surveys: state.surveys,
        auth: state.auth
      };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, SurveyActions, surveyMetaActions, modalActions), dispatch);
  }

  return ReactRedux.connect(mapStateToProps, mapDispatchToProps)(SurveyComponent);
};

module.exports = checkSurveys;


// WEBPACK FOOTER //
// ./src/common/routes/survey/components/checkSurveys.jsx